export const formatEventForCard = (event) => {
    if (!event) {
      return {
        mainImage: null,
        title: '',
        artistePrincipalSlug: '',
        subtitle: '',
        date: '',
        dateFin: '',
        description: '',
        typePerformance: '',
        link: '',
        additionalArtists: [],
      };
    }
  
    const artistePrincipal = event.artistePrincipal || {};
    
    // Utiliser le titre de l'événement comme fallback
    const artistName = (artistePrincipal.name === "Artiste non disponible")
      ? event.title?.rendered
      : artistePrincipal.name;
  
    // Récupérer les artistes additionnels depuis artiste_add
    const additionalArtists = event.artiste_add || [];

    return {
      mainImage: artistePrincipal.photo || null,
      title: artistName || 
             artistePrincipal.title?.rendered || 
             artistePrincipal.post_title || 
             event.title?.rendered || 
             'Artiste à venir',
      artistePrincipalSlug: artistePrincipal.slug || event.slug || '',
      subtitle: event.artistesSupport?.map(artist => 
        artist.name || artist.title?.rendered || artist.post_title
      ).filter(Boolean).join(', ') || '',
      date: event.date || event.acf?.date || '',
      dateFin: event.date_fin || event.acf?.date_fin || '',
      description: event.content?.rendered || event.description || '',
      typePerformance: artistePrincipal.type_performance || '',
      link: event.link || '',
      additionalArtists: additionalArtists.map(artist => artist.name).filter(Boolean),
      addInfosEvent: event.add_infos_event || null,
    };
  };

export const formatDateParts = (dateString, dateFinString = null) => {
    if (!dateString) return { dayOfWeek: '', day: '', month: '' };

    try {
        const date = new Date(dateString);
        const jours = ['DIM', 'LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM'];
        const mois = [
            'JANVIER', 'FÉVRIER', 'MARS', 'AVRIL', 'MAI', 'JUIN',
            'JUILLET', 'AOÛT', 'SEPTEMBRE', 'OCTOBRE', 'NOVEMBRE', 'DÉCEMBRE'
        ];

        const dateParts = {
            dayOfWeek: jours[date.getDay()],
            day: date.getDate().toString().padStart(2, '0'),
            month: mois[date.getMonth()]
        };

        if (dateFinString) {
            const dateFin = new Date(dateFinString);
            dateParts.dateFin = {
                day: dateFin.getDate().toString().padStart(2, '0'),
                month: mois[dateFin.getMonth()]
            };
        }

        return dateParts;
    } catch (error) {
        console.error('Erreur de formatage de date:', error);
        return { dayOfWeek: '', day: '', month: '' };
    }
};